<h5 class="text--h5">{{ 'dairyresults.attention-summary.header' | translate }}</h5>
<div class="spacing--margin-vertical">
  @if (hasData()) {
    <div class="flex__child--auto">
      <div class="table-desktop">
        <table
          mat-table
          #table
          [dataSource]="dataSource"
          class="table-desktop__table--alternate-rows cust-table"
        >
          <ng-container matColumnDef="groupName">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'dairyresults.attention-summary.groupName' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.groupName }}</td>
            <td mat-footer-cell *matFooterCellDef>{{ footer.groupName }}</td>
          </ng-container>
          <ng-container matColumnDef="numberOfAnimals">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'dairyresults.attention-summary.numberOfAnimals' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="mat-column-number">
              {{ element.numberOfAnimals | number: '1.0-0' }}
            </td>
            <td mat-footer-cell *matFooterCellDef class="mat-column-number">
              {{ footer.numberOfAnimals | number: '1.0-0' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="fatPercentageLowerThenProtein">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'dairyresults.attention-summary.fatPercentageLowerThenProtein' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="mat-column-number">
              {{ element.fatPercentageLowerThenProtein }}
            </td>
            <td mat-footer-cell *matFooterCellDef class="mat-column-number">
              {{ footer.fatPercentageLowerThenProtein }}
            </td>
          </ng-container>
          <ng-container matColumnDef="maximumFatProteinPercentage">
            <th mat-header-cell *matHeaderCellDef>
              {{ maximumFatProteinPercentageLabel }}
            </th>
            <td mat-cell *matCellDef="let element" class="mat-column-number">
              {{ element.maximumFatProteinPercentage }}
            </td>
            <td mat-footer-cell *matFooterCellDef class="mat-column-number">
              {{ footer.maximumFatProteinPercentage }}
            </td>
          </ng-container>
          <ng-container matColumnDef="ketose">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'dairyresults.attention-summary.ketose' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="mat-column-number">
              {{ element.ketose }}
            </td>
            <td mat-footer-cell *matFooterCellDef class="mat-column-number">
              {{ footer.ketose }}
            </td>
          </ng-container>
          <ng-container matColumnDef="minimumProteinPercentage">
            <th mat-header-cell *matHeaderCellDef>
              {{ minimumProteinPercentageLabel }}
            </th>
            <td mat-cell *matCellDef="let element" class="mat-column-number">
              {{ element.minimumProteinPercentage }}
            </td>
            <td mat-footer-cell *matFooterCellDef class="mat-column-number">
              {{ footer.minimumProteinPercentage }}
            </td>
          </ng-container>
          <ng-container matColumnDef="decreasePercentageKgMilk">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'dairyresults.attention-summary.decreasePercentageKgMilk' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="mat-column-number">
              {{ element.decreasePercentageKgMilk }}
            </td>
            <td mat-footer-cell *matFooterCellDef class="mat-column-number">
              {{ footer.decreasePercentageKgMilk }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </div>
    </div>
  }
  <agr-notification-empty
    [isEmpty]="!hasData()"
    [emptyTitle]="'no_items' | translate"
    emptyImage="/assets/images/no-items.png"
    class="complete__notification-empty"
  >
  </agr-notification-empty>
</div>
